export const MAGIC_LINK_ENDPOINT = "/nxt/auth/magic_link"

export type MagicLinkRequestArgs = {
  email: string
  returnUrl?: string
  spaceId?: string
}

export type MagicLinkFetcher = (
  url: string,
  options?: RequestInit,
) => Promise<unknown>

export const createMagicLinkRequest = ({
  email,
  returnUrl,
  spaceId,
}: MagicLinkRequestArgs): [string, RequestInit] => {
  return [
    MAGIC_LINK_ENDPOINT,
    {
      method: "POST",
      body: JSON.stringify({ email, returnUrl, spaceId }),
    },
  ]
}

export const createMagicLinkSender = (requester: MagicLinkFetcher) => {
  return async (args: MagicLinkRequestArgs) => {
    try {
      const [url, options] = createMagicLinkRequest(args)
      const response = await requester(url, options)
      return response
    } catch (error) {
      console.error("Error sending magic link:", error)
      return undefined
    }
  }
}
